const { connect } = require('react-redux');
const BrokerCustomWalletPortfolio = require ('./brokerCustomWalletPortfolio');
// @ actions
const portfolios = require('../../actions/brokerCustomWalletPortfolios');
const editablePortfolio = require('../../actions/brokerCustomWalletEditablePortfolio.js');

module.exports.BrokerCustomWalletPortfolio = connect(
    state => ({
        immBrokerCustomWalletInterveners: state.brokerCustomWalletInterveners,
        immNamePortfolioOnEdition: state.brokerCustomWalletPortfolios.get('namePortfolioOnEdition'),
        immSkipLeaveEditionModal: state.brokerCustomWalletPortfolios.get('skipLeaveEditionModal'),
        idDefaultView: state.brokerCustomWalletPortfolios.get('idPortfolioAccountDefaultView')
    }),
    {
        getDetailsByPortfolio: portfolios.getDetailsByPortfolio,
        confirmedChangeDefault: portfolios.confirmedChangeDefault,
        setPortfolioToDelete: portfolios.setPortfolioToDelete,
        leaveEditionToDelete: portfolios.leaveEditionToDelete,
        leaveEditionToEdition: portfolios.leaveEditionToEdition,
        setOnEditMode: portfolios.setPortfolioOnEditionMode,
        setOnNextEditMode: portfolios.setPortfolioOnNextEditMode,
        loadEditablePortfolioById: editablePortfolio.loadEditablePortfolioById,
        setExpanded: portfolios.setExpanded,
        getContractsList: editablePortfolio.getContractsList
    }
)(BrokerCustomWalletPortfolio);
